

<template>
    <div class="assessment-container">
        <div class="p-bottom-20">
            <a-select class="width-160" v-model="taskId" placeholder="评估任务"
                @change="getKlassTaskList">
                <a-select-option v-for="item in taskList" :value="item.id" :key="item.id">
                    {{ item.title }}
                </a-select-option>
            </a-select>
			<a-button class="fr m-left-20" type="primary" icon="plus" @click="showCreateModal">创建评估任务</a-button>
			<a-button v-if="canDelete" class="fr m-left-20" type="danger" @click="delTaskHandle">删除</a-button>
			<!-- <a-button v-if="getTask(taskId).status==='ARCHIVED'" class="fr m-left-20" @click="updateTaskStatusHandle">恢復</a-button> -->
			<a-button v-else class="fr m-left-20" type="danger" @click="updateTaskStatusHandle">归档</a-button>
			<a-button class="fr" @click="viewArchivedTask">归档任务管理</a-button>
        </div>
        <a-table :columns="columns" :data-source="tableSource" :rowKey="record => record.id" :pagination="false" bordered>
			<template slot="task_id" slot-scope="text">
				<span>{{ getTask(text).title || "--" }}</span>
			</template>

			<template slot="teacher" slot-scope="text, record">
				<span>{{ getTeacherName(record) }}</span>
			</template>

			<template slot="operation" slot-scope="text, record">
				<a class="assessment-table_btn" href="javascript:;" @click="viewKlassAssessment(record)">
					<svg-icon iconClass="eye"></svg-icon>
					<span class="assessment-table_btn_text">查看</span>
				</a>
			</template>
        </a-table>

		
		<a-modal title="创建评估任务" v-model="modalInfo.show" :confirm-loading="modalInfo.loading" @ok="createAssessmentHandle">
			<div class="assessment-modal_item">
				<span class="assessment-modal_label">任务名称：</span>
				<a-input class="assessment-modal_value" v-model="modalInfo.title" placeholder="请输入任务名称" />
			</div>
		</a-modal>

		<a-modal title="管理评估任务" width="1000px" v-model="showManageModal">
			<a-table :data-source="archiveTaskList" :scroll="{y: 600}" :pagination="false" bordered>
				<a-table-column key="title" title="任务名称" data-index="title"></a-table-column>
				<a-table-column key="status" title="任务任务状态" data-index="status"></a-table-column>
				<a-table-column key="action" title="操作">
					<template slot-scope="text, record">
						<div class="assessment-table_btn">
							<a class="assessment-table_btn" href="javascript:;" @click="viewKlassAssessment(record)">
								<svg-icon iconClass="redo"></svg-icon>
								<span class="assessment-table_btn_text">恢复</span>
							</a>
						</div>
					</template>
				</a-table-column>
			</a-table>
			<div slot="footer"></div>
		</a-modal>
    </div>
</template>

<script>
import { getKlassTaskColumns } from "./constant";
import AssessmentService from "@/api/assessmentService";
import TeacherInfoService from "@/api/teacherService";
import { mapGetters } from "vuex";
export default {
	name: "assessment",
	data() {
		return {
			columns: getKlassTaskColumns(),
			tableSource: [],
			taskList: [],
			archiveTaskList: [],
			taskId: undefined,
			modalInfo: {
				show: false,
				loading: false,
				title: undefined,
			},
			teacherList: [],
			showManageModal: false
		};
	},

	computed: {
		...mapGetters(["schoolInfo"]),
		getTask() {
			return function(taskId) {
				const task =
					this.taskList.find((item) => item.id === taskId) || {};

				return task;
			};
		},

		getTeacherName() {
			return function(record) {
				const teachers = this.teacherList.filter(
					(item) =>
						item.teachers &&
						item.teachers.find(
							(teacher) =>
								teacher.klass &&
								teacher.klass.id === record.klass_id
						)
				);
				return teachers.map((item) => item.name).join("、") || "--";
			};
		},

		canDelete() {
			const students_initialized = this.tableSource.filter(
				(item) => item.students_initialized.length
			);
			const students_finished = this.tableSource.filter(
				(item) => item.students_finished.length
			);
			const students_sent = this.tableSource.filter(
				(item) => item.students_sent.length
			);
			return (
				!students_initialized.length &&
				!students_finished.length &&
				!students_sent.length
			);
		},
	},

	created() {
		this.getTeacherList();
		this.getTaskList();
	},

	methods: {
		getTeacherList() {
			TeacherInfoService.getTeacherInfoListService({
				school_id: this.schoolInfo.id,
			}).then((res) => {
				this.teacherList = res || [];
			});
		},
		getTaskList() {
			AssessmentService.getTaskListService({
				school_id: this.schoolInfo.id,
				status: "ACTIVE"
			}).then((res = []) => {
				this.taskList = res.reverse();
				if (this.taskList.length) {
					this.taskId = this.taskId || this.taskList[0].id;
					this.getKlassTaskList();
				}
			});
		},

		getKlassTaskList() {
			AssessmentService.getKlassTaskListService({
				task_id: this.taskId,
			}).then((res = []) => {
				this.tableSource = res;
			});
		},

		createAssessmentHandle() {
			if (!this.modalInfo.title || !this.modalInfo.title.trim().length) {
				this.$message.warning("请输入任务名称");
				return;
			}

			this.modalInfo.true = false;
			AssessmentService.createTaskService({
				school_id: this.schoolInfo.id,
				title: this.modalInfo.title.trim(),
			})
				.then((res) => {
					this.taskList.push(res);
					this.modalInfo.show = false;
				})
				.catch(() => {
					this.modalInfo.loading = false;
				});
		},

		showCreateModal() {
			this.modalInfo = {
				show: true,
				loading: false,
				title: undefined,
			};
		},

		viewKlassAssessment(record) {
			this.$router.push({
				name: "assessmentList",
				query: { klass_id: record.klass_id, task_id: this.taskId, status: "ACTIVE" },
			});
		},

		delTaskHandle() {
			const task = this.taskList.find((item) => item.id === this.taskId);
			this.$confirm({
				title: "提示信息",
				content: `是否删除评估任务 ${task.title}`,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						AssessmentService.delTaskService({
							taskId: task.id,
						})
							.then(() => {
								this.taskId = undefined;
								this.$message.success("操作成功");
								this.getTaskList();
								resolve();
							})
							.catch((err) => {
								this.$message.error("操作失败，请检查后重试");
								reject(err);
							});
					});
				},
			});
		},

		updateTaskStatusHandle() {
			const task = this.taskList.find((item) => item.id === this.taskId);
			this.$confirm({
				title: "提示信息",
				content: `是否${
					task.status === "ACTIVE" ? "归档" : "恢复"
				}评估任务 ${task.title}`,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						AssessmentService.updateTaskStatusService({
							taskId: task.id,
							isActive: task.status === "ACTIVE",
						})
							.then(() => {
								this.taskId = undefined;
								this.$message.success("操作成功");
								this.getTaskList();
								resolve();
							})
							.catch((err) => {
								this.$message.error("操作失败，请检查后重试");
								reject(err);
							});
					});
				},
			});
		},

		viewArchivedTask () {
			this.$router.push({ name: "archivedTask" })
		}
	},
};
</script>

<style lang="less" scoped>
.assessment {
	&-container {
		background: #ffffff;
		min-height: calc(100% - 65px);
		margin-top: 15px;
		padding: 28px 28px 2px 30px;
	}

	&-table {
		&_btn {
			display: flex;
			flex-flow: nowrap row;
			align-items: center;
			justify-content: center;
			line-height: 1;

			&_text {
				margin-left: 5px;
				line-height: 1;
			}

			&_disabled {
				cursor: not-allowed;
				color: rgba(0, 0, 0, 0.25);
				border-color: #d9d9d9;
			}
		}
	}

	&-modal {
		&_item {
			display: flex;
			flex-flow: nowrap row;
			align-items: center;
			margin-bottom: 10px;
			padding-left: 50px;
		}

		&_label {
			width: 100px;
		}

		&_value {
			width: 300px;
			text-align: left;
		}
	}
}
</style>
